import { render, staticRenderFns } from "./freeReserveBottomExpNew.vue?vue&type=template&id=0aa16a3a&scoped=true&"
import script from "./freeReserveBottomExpNew.vue?vue&type=script&lang=js&"
export * from "./freeReserveBottomExpNew.vue?vue&type=script&lang=js&"
import style0 from "./freeReserveBottomExpNew.vue?vue&type=style&index=0&id=0aa16a3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa16a3a",
  null
  
)

export default component.exports